export const setSideDataRequest = sideData => ({
  type: 'SET_SIDE_DATA',
  payload: { sideData }
});
export const setSideOpenState = sideOpenState => ({
  type: 'SET_SIDE_OPEN_STATE',
  payload: { sideOpenState }
});
